import React from 'react';
import {SmsLogList} from "components/sms-log/SmsLogList";
import {Provider} from "components/sms-log/SmsLogContext";

export const SmsLogs = () => {

    return (
        <Provider>
            <SmsLogList/>
        </Provider>
    );
}
